import React from 'react';

/**
 * "Questions? Contact Sunny Days at billing@sunnydays.org · 555-0100." The
 * school, not Perfect Day, answers questions about a payment; the line is
 * the same on every post-Checkout screen so a parent always has a way out.
 */
const SchoolContactLine = ({ school }) => {
	if (!school?.name) return null;

	return (
		<p className="text-center text-[12px] leading-[18px] text-pay-muted">
			Questions? Contact {school.name}
			{school.contact_email ? (
				<>
					{' at '}
					<a href={`mailto:${school.contact_email}`} className="underline">
						{school.contact_email}
					</a>
				</>
			) : null}
			{school.phone ? ` · ${school.phone}` : ''}.
		</p>
	);
};

export default SchoolContactLine;
